import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

@Component({
  selector: 'admin-form-right-side',
  templateUrl: './admin-form-right-side.component.html',
  styleUrls: ['./admin-form-right-side.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule],
})
export class AdminFormRightSideComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
